import { GET } from './NetService';

const Action = "Estadisticas/";

export async function GetPacientesActivos(bsignal)
{
    return await GET(Action + "censo/pacientes",bsignal);
}

export async function GetPacientesIngresados(bsignal,datestart,dateend)
{
    return await GET(Action + "censo/pacientes/ingresados", bsignal, {fechaInicial: datestart, fechaFinal: dateend});
}

export async function GetPacientesEgresados(bsignal,datestart,dateend)
{
    return await GET(Action + "censo/pacientes/egresados", bsignal, {fechaInicial: datestart, fechaFinal: dateend});
}

export async function GetPacientesIngresadosDias(bsignal,datestart,dateend)
{
    return await GET(Action + "censo/pacientes/ingresados/dias", bsignal, {fechaInicial: datestart, fechaFinal: dateend});
}

export async function GetPacientesEgresadosDias(bsignal,datestart,dateend)
{
    return await GET(Action + "censo/pacientes/egresados/dias", bsignal, {fechaInicial: datestart, fechaFinal: dateend});
}

export async function GetCuentasFacturadasDias(bsignal,datestart,dateend)
{
    return await GET(Action + "cuentas/facturadas/dias", bsignal, {fechaInicial: datestart, fechaFinal: dateend});
}